import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKeypointAdd = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.74268 16.2426C3.74268 14.2426 2.74268 13.2426 2.74268 12C2.74268 10.7574 3.74268 9.75736 5.74268 7.75736L7.75739 5.74265C9.75739 3.74265 10.7574 2.74265 12 2.74265C13.2427 2.74265 14.2427 3.74265 16.2427 5.74265L18.2574 7.75736C20.2574 9.75736 21.2574 10.7574 21.2574 12C21.2574 13.2426 20.2574 14.2426 18.2574 16.2426L16.2427 18.2574C14.2427 20.2574 13.2427 21.2574 12 21.2574C10.7574 21.2574 9.75739 20.2574 7.75739 18.2574L5.74268 16.2426ZM12 17C11.4477 17 11 16.5523 11 16V13H8C7.44771 13 7 12.5523 7 12C7 11.4477 7.44771 11 8 11H11V8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgKeypointAdd);
export { ForwardRef as ReactComponent };
